export default {
	namespaced: true,

	state: {
		isInitialized: false,

		showMessagebarFooter: false,
		showSettingNavigationDrawer: false,
		showInformationDialog: false,
		showInformationSnackbar: false,
		showToolbarTabs: false,

		searchbarList: {
			startDate: null,
			endDate: null,
			word: null,
			tag: null
		},

		chatList: {
			code: null,
			name: null,
			type: null
		},

		contactList: {
			uid: null
		},

		informationDialog: {
			title: null,
			text: null,
			img: {
				url: null
			},
			okButton: {
				title: 'OK',
				link: {
				//	to: '/'
				}
			}
		},

		informationSnackbar: {
			text: null,
			icon: null,
			link: {
			//	to: '/'
			},
			timeout: 5000 // ms
		},

		toolbar: {
			menu: null
		}
	},

	getters: {
		get: state => state
	},

	mutations: {
		setValue (state, [key, value]) {
			state[key] = value;
		},
		setSubValue (state, [key, subKey, value]) {
			state[key][subKey] = value;
		}
	},

	actions: {
	}
}
